import React from 'react';
import { Link } from 'react-router-dom';

const Warranty: React.FC = () => {
  return (
    <div className="container-custom py-12 md:py-24">
      <h1 className="mb-12 text-center">Our 2-10 Warranty</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Left Column - Iframe and What's Covered */}
        <div>
          {/* Iframe Section */}
          <div className="mb-8">
            <iframe 
              width="600" 
              height="645" 
              src="https://www.2-10.com/builder/210-no-basement/" 
              frameBorder="0" 
              className="w-full shadow-lg rounded-lg"
              title="2-10 Home Warranty Information"
            />
          </div>

          {/* What's Covered Section */}
          <div className="bg-primary/5 rounded-lg p-8">
            <h2 className="text-2xl font-serif mb-6">What's Covered?</h2>
            <ul className="space-y-6">
              <li className="flex items-start">
                <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-4">
                  <span className="font-bold">10</span>
                </div>
                <div>
                  <span className="font-medium block mb-1">Years Structural Coverage</span>
                  <span className="text-gray-600">Full coverage for load-bearing components</span>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-4">
                  <span className="font-bold">2</span>
                </div>
                <div>
                  <span className="font-medium block mb-1">Years Systems Coverage</span>
                  <span className="text-gray-600">Protection for electrical, plumbing, heating, cooling, ventilating, and mechanical systems</span>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1 mr-4">
                  <span className="font-bold">1</span>
                </div>
                <div>
                  <span className="font-medium block mb-1">Year Workmanship Coverage</span>
                  <span className="text-gray-600">Coverage against defects in workmanship and materials</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Right Column - Content */}
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-serif mb-4">Protecting Your Investment</h2>
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
              <p className="text-gray-700">
                Purchasing a new home is one of the largest investments you will ever make, which is why it's important to ensure your home comes with protection. As a 2-10 Home Buyers Warranty® builder member, Yeremian Lifestyle Homes provides every home we build with 10 full years of structural home warranty protection from the nation's leading home warranty company.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-serif mb-4">What does being a 2-10 HBW member mean for your home?</h2>
            <div className="space-y-6">
              <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
                <p className="text-gray-700">
                  2-10 HBW only accepts the best builders into their program. To become a member, Yeremian Lifestyle Homes went through an extensive screening process that measures our building practices against strict underwriting guidelines to ensure we maintain a high quality product in addition to a careful inspection of our workmanship.
                </p>
              </div>
              
              <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
                <p className="text-gray-700">
                  With the purchase of your new home, you'll receive a copy of the structural home warranty contract that explains what is covered as well as a maintenance booklet to give you tips on how to care for your home. In addition, the warranty is fully-transferable, which increases the resale value of your home.
                </p>
              </div>
            </div>
          </section>

          {/* Call to Action */}
          <div className="bg-primary/5 rounded-lg p-8 mt-8">
            <h3 className="text-xl font-serif mb-3">Have Questions About Our Warranty?</h3>
            <p className="text-gray-700 mb-4">
              Our team is here to help you understand your warranty coverage and answer any questions you may have.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Contact Us Today
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Warranty; 